function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "15",
  viewBox: "0 0 16 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.132.889c4.082 0 7.393 2.953 7.393 6.595s-3.31 6.595-7.393 6.595c-.242 0-.48-.011-.718-.031-.834-.072-1.469-.75-1.464-1.568l.008-1.601c.004-.716-.468-1.326-1.178-1.516l-2.85-.77c-.75-.2-1.234-.877-1.173-1.632C1.045 3.436 4.443.89 8.132.89zm1.217 8.36c.919 0 1.662.725 1.662 1.62 0 .894-.743 1.618-1.662 1.618-.918 0-1.661-.726-1.661-1.619S8.433 9.25 9.349 9.25zm1.675-5.89c.678 0 1.227.534 1.227 1.195 0 .66-.55 1.193-1.227 1.193-.678 0-1.226-.534-1.226-1.193 0-.66.55-1.194 1.226-1.194zM7.26 2.89c.678 0 1.227.534 1.227 1.193 0 .66-.549 1.196-1.227 1.196s-1.225-.535-1.225-1.196c0-.66.549-1.193 1.225-1.193zM3.886 4.706c.676 0 1.225.534 1.225 1.193 0 .66-.55 1.196-1.225 1.196-.677 0-1.226-.535-1.226-1.196 0-.66.548-1.193 1.226-1.193z",
  fill: "#fff"
})));